import i18next from "i18next";
import { NS_TELEHEALTH_CORE, telehealthCoreResoucesEn } from ".";
import {
  initI18nReact,
  LOCALE_EN,
  LOCALE_ES_US,
  LOCALE_PSEUDO,
} from "@growtherapy/i18n";

export const CROWDIN_DISTRIBUTION_HASH = "e-55b8f1847490f0b920ba3b3mgk";

export const initI18n = (): void => {
  initI18nReact(i18next, {
    defaultNS: NS_TELEHEALTH_CORE,
    resources: telehealthCoreResoucesEn,
    otaOptions: {
      distributionHash: CROWDIN_DISTRIBUTION_HASH,
      localePath: "/locales",
      otaLanguages: [LOCALE_ES_US],
    },
    // Important for mixing bundled + backend-loaded languages
    partialBundledLanguages: true,
    // Supported languages
    load: "currentOnly",
    // Only load exact language codes, prevents 'es' fallback attempts
    supportedLngs: [LOCALE_EN, LOCALE_ES_US, LOCALE_PSEUDO],
    // Fallback behavior for missing values. empty stings are not valid translations
    returnEmptyString: false,
    // Disable Suspense so components render with EN fallback while async translations load
    react: { useSuspense: false },
  });
};
